import { get, omit } from 'lodash';
import * as ReactBootstrap from 'react-bootstrap';
import React, { useMemo } from 'react';
import { TBaseTag } from '../CustomTag/types';

const BootstrapTag: React.FC<{
  name?: string;
  tagProps: Partial<TBaseTag>;
  children: React.ReactNode;
}> = React.memo(({ name, tagProps, children }) => {
  const Tag = useMemo(() => get(ReactBootstrap, name || 'unknown'), [name]);
  if (!Tag || tagProps.excluded) return null;

  return <Tag {...omit(tagProps, 'excluded')}>{children}</Tag>;
});
BootstrapTag.displayName = 'BootstrapTag';
export default BootstrapTag;
